import { motion } from 'framer-motion';

const steps = [
  {
    step: '01',
    label: 'Signal',
    title: 'Submit the brief.',
    body: 'A 3-minute application. Business, revenue, use of capital. No credit pull, no fee.',
    duration: '3 min',
  },
  {
    step: '02',
    label: 'Strike',
    title: 'Underwriting in motion.',
    body: 'A senior principal reviews the file the same day. Direct conversation — no phone tree, no forms.',
    duration: '≤ 3 hrs',
  },
  {
    step: '03',
    label: 'Sting',
    title: 'Terms & structure.',
    body: 'Custom offer built around your revenue, seasonality, and growth curve. Sign electronically.',
    duration: '1–2 hrs',
  },
  {
    step: '04',
    label: 'Settle',
    title: 'Capital deployed.',
    body: 'Funds wire directly to your operating account. Same-day for domestic files under $2M.',
    duration: 'Same day',
  },
];

export default function Process() {
  return (
    <section
      id="process"
      className="relative bg-[#050505] py-28 lg:py-40"
      data-testid="process-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20 lg:mb-28">
          <div className="lg:col-span-4 flex items-start gap-4">
            <span className="w-10 h-px bg-[#c2a978] mt-3" />
            <span className="text-[10px] tracking-[0.5em] uppercase text-[#c2a978]">
              Ch. 03 — Process
            </span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1 }}
            className="lg:col-span-8 font-serif text-3xl lg:text-5xl leading-[0.95] tracking-[-0.02em]"
          >
            From brief to<br />
            <span className="italic text-[#c2a978]">bank wire</span>.
          </motion.h2>
        </div>

        <div className="relative">
          {/* Vertical timeline */}
          <div className="absolute left-0 lg:left-1/2 top-0 bottom-0 w-px bg-[#c2a978]/20 hidden lg:block" />
          {steps.map((s, i) => (
            <motion.div
              key={s.step}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
              className={`relative grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-20 pb-16 lg:pb-24 ${
                i % 2 === 0 ? '' : 'lg:direction-rtl'
              }`}
              data-testid={`process-step-${i}`}
            >
              {/* Dot */}
              <span className="hidden lg:block absolute left-1/2 top-2 -translate-x-1/2 w-3 h-3 rotate-45 bg-[#c2a978]" />

              <div className={i % 2 === 0 ? 'lg:text-right lg:pr-12' : 'lg:col-start-2 lg:pl-12'}>
                <div className="flex lg:justify-end items-baseline gap-4 mb-4">
                  {i % 2 !== 0 && <span className="font-serif italic text-[#c2a978] text-5xl">{s.step}</span>}
                  <span className="text-[10px] tracking-[0.4em] uppercase text-[#c2a978]">
                    {s.label}
                  </span>
                  {i % 2 === 0 && <span className="font-serif italic text-[#c2a978] text-5xl">{s.step}</span>}
                </div>
                <h3 className="font-serif text-2xl lg:text-3xl text-[#f5f5f0] leading-tight mb-3">
                  {s.title}
                </h3>
                <p className="text-[#8a8a8a] text-base leading-relaxed lg:max-w-sm lg:ml-auto">
                  {s.body}
                </p>
                <div className="mt-5 text-[10px] tracking-[0.35em] uppercase text-[#8a8a8a]">
                  Typical · <span className="text-[#c2a978]">{s.duration}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
